import "../css/Panel.css";
import "../css/Patient.css";
import "../css/PatientSearch.css";
import "../css/custom-datatable.css";
import "../css/Dashboard.css";
import "../css/CRM.css";
import { useState, useEffect } from "react";
import ButtonIconH from "../components/ButtonIconH";
import { DashboardDocumentManagement } from "../components/DashboardDocumentManagement";
import { AutomatedDocumentManagement } from "../components/AutomatedDocumentManagement";
import { PrescriptionDocumentManagement } from "../components/PrescriptionDocumentManagement";
import { StorageQuotaBar } from "../components/StorageQuotaBar";
import { post } from "../js/post";
import { userData } from "../js/utils";

export default function DocumentManagement({
  show,
  createPopupQuestion,
  removePopupQuestion,
}) {
  const [quote, setQuote] = useState({
    maximoCuotaValor: 0,
    maximoCuotaUnidad: "",
    ocupacionCuotaValor: 0,
    ocupacionCuotaUnidad: "",
    porcentajeOcupacion: 0,
  });

  const [selectedOption, setSelectedOption] = useState({
    dashboard: true,
    automated: false,
    prescriptions: false,
  });

  async function getStorageQuote() {
    const response = await post(
      "support-extra/gestionDocumental/ObtenerCuotaGD.php",
      {
        token: userData.token,
      },
    );
    setQuote(response);
  }

  useEffect(() => {
    getStorageQuote();
  }, []);

  function handleActiveOption(key) {
    setSelectedOption((prev) =>
      Object.keys(prev).reduce((acc, curr) => {
        acc[curr] = curr === key;
        return acc;
      }, {}),
    );
  }

  if (!show) {
    return <></>;
  }

  return (
    <div className="patient-data">
      <div className="patient-data-header">
        <span className="header-text">Gestión documental</span>
      </div>
      <div
        className="patient-data-content document-management-content"
        style={{ paddingBottom: 20 }}
      >
        <div className="action-bar">
          <div className="action-bar-resume">
            <span className="signed-text">Gestión documental</span>
          </div>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: 20,
          }}
        >
          <div className="dashboard-content">
            <div className="patient-search-content dashboard-bg">
              <div
                className="dashboard-content-data"
                style={{ alignItems: "center" }}
              >
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "flex-end",
                  }}
                >
                  <StorageQuotaBar data={quote} />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 10,
                  }}
                >
                  <ButtonIconH
                    text="Dashboard"
                    selected={selectedOption.dashboard}
                    onClick={() => {
                      handleActiveOption("dashboard");
                    }}
                  ></ButtonIconH>
                  <ButtonIconH
                    text="Automatizada"
                    selected={selectedOption.automated}
                    onClick={() => {
                      handleActiveOption("automated");
                    }}
                  ></ButtonIconH>
                  <ButtonIconH
                    text="Prescripciones"
                    selected={selectedOption.prescriptions}
                    onClick={() => {
                      handleActiveOption("prescriptions");
                    }}
                  ></ButtonIconH>
                </div>
                {selectedOption.dashboard && (
                  <DashboardDocumentManagement
                    createPopupQuestion={createPopupQuestion}
                    removePopupQuestion={removePopupQuestion}
                  />
                )}
                {selectedOption.automated && (
                  <AutomatedDocumentManagement
                    createPopupQuestion={createPopupQuestion}
                    removePopupQuestion={removePopupQuestion}
                  />
                )}
                {selectedOption.prescriptions && (
                  <PrescriptionDocumentManagement
                    createPopupQuestion={createPopupQuestion}
                    removePopupQuestion={removePopupQuestion}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
